// extracted by mini-css-extract-plugin
module.exports = {"root":"ActiveSwitch_root__1lni2","content":"ActiveSwitch_content__1J7aq","active":"ActiveSwitch_active__1g0uO"};